import type { Coupon, CouponIdentifiers } from '../../../../schema/coupon/entry.js';
import { getInstanceClient } from '../../../di/entry.browser.js';
import type { ActionStatus } from '../../../lib/entry.js';

type UpdateBetAmountArgs = CouponIdentifiers;

type DrawCount = Coupon['week'];
type UpdateCouponPayloadParams = Partial<Pick<Coupon, 'betAmount'> & { drawCount: DrawCount }>;

/**
 * Updates a given coupon bet amount.
 *
 * @param payload Object containing new coupon values
 * @param root0 function args
 * @param root0.couponId Unique id of the coupon
 * @param root0.couponIndex Specific coupon id in order
 * @returns SUCCESS if successful, otherwise ERROR
 */
export async function updateCoupon(
  payload: UpdateCouponPayloadParams,
  { couponId, couponIndex }: UpdateBetAmountArgs
): Promise<ActionStatus> {
  const updateCouponController = getInstanceClient('IUpdateCouponController');

  try {
    await updateCouponController(payload, { couponId, couponIndex });

    return 'SUCCESS';
  } catch {
    return 'ERROR';
  }
}
